import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CursorGlow from "@/components/CursorGlow";
import { motion, useScroll } from "framer-motion";

// Pages
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Developers from "@/pages/Developers";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import WhyNaviMumbai from "@/pages/WhyNaviMumbai";
import InvestmentInsights from "@/pages/InvestmentInsights";

import FeaturedListings from "@/pages/FeaturedListings";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      style={{ scaleX: scrollYProgress }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#D4AF37] to-[#F4D98B] origin-left z-[9999]"
    />
  );
};

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CursorGlow />
        <ScrollProgress />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/properties" element={<Layout><Properties /></Layout>} />
          <Route path="/properties/:id" element={<Layout><PropertyDetail /></Layout>} />
          <Route path="/listings" element={<Layout><FeaturedListings /></Layout>} />
          <Route path="/developers" element={<Layout><Developers /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/consultation" element={<Layout><Consultation /></Layout>} />
          <Route path="/why-navi-mumbai" element={<Layout><WhyNaviMumbai /></Layout>} />
          <Route path="/insights" element={<Layout><InvestmentInsights /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
